import { makeVar, useReactiveVar } from "@apollo/client";

import { AutocompleteOptionType } from "../models/autocomplete";

export const selectedLocationVariable = makeVar<AutocompleteOptionType | null>(
  null
);

export const useSelectedLocation = () =>
  useReactiveVar(selectedLocationVariable);

// Track location IDs when a tag is selected (for filtering events by multiple locations)
export const selectedTagLocationIdsVariable = makeVar<string[]>([]);

export const useSelectedTagLocationIds = () =>
  useReactiveVar(selectedTagLocationIdsVariable);
